const local = {
  API_ROOT: 'https://local-api.avatarnutrition.com',
  BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
  STREAMCHAT: {
    userPrefix: 'local-',
    portalUserPrefix: 'local-avnportal-',
    apiKey: 'cy83mgp8tqpz',
    apiKeyFBBC: 'wmbd4tcrdq4c',
  },
}
  
const dev = {
  API_ROOT: 'https://dev-api.avatarnutrition.com',
  BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
  STREAMCHAT: {
    userPrefix: 'dev-',
    portalUserPrefix: 'dev-avnportal-',
    apiKey: 'cy83mgp8tqpz',
    apiKeyFBBC: 'wmbd4tcrdq4c',
  },
}

const uat = {
  API_ROOT: 'https://uat-api.avatarnutrition.com',
  BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
  STREAMCHAT: {
    userPrefix: 'uat-',
    portalUserPrefix: 'uat-avnportal-',
    apiKey: 'cy83mgp8tqpz',
    apiKeyFBBC: 'wmbd4tcrdq4c',
  },
}

const prod = {
  API_ROOT: 'https://api.avatarnutrition.com',
  BRAINTREE_DROPIN: 'production_7jsf8j4b_tm4gmb6qfhhnby8y',
  STREAMCHAT: {
    userPrefix: '',
    portalUserPrefix: 'avnportal-',
    apiKey: 'cy83mgp8tqpz',
    apiKeyFBBC: 'wmbd4tcrdq4c',
  },
}
    
const config = (function(env) {
  switch(env) {
    case 'prod':
      return prod;
    case 'uat': 
      return uat;
    case 'dev': 
      return dev;
    default: 
      return local;
  }
})(process.env.REACT_APP_STAGE)

export default config
  